/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { headerStyles } from "@insite/content-library/Widgets/Budget/BudgetManagementHeader";
import { css } from "styled-components";

headerStyles.titleGridItem = {
    width: [10, 9, 7, 4, 5],
};

headerStyles.buttonsGridItem = {
    width: [2, 3, 5, 8, 7],
    css: css`
        display: flex;
        justify-content: flex-end;
        align-items: center;
    `,
};

headerStyles.actionButtonsHidden = {
    css: css`
        display: inline-block;
        padding-left: 10px;
    `,
};

headerStyles.costCodesButton = {
    variant: "secondary",
    css: css`
        white-space: nowrap;
    `,
};

headerStyles.assignBudgetsButton = {
    variant: "secondary",
    css: css`
        white-space: nowrap;
        margin-left: 10px;
    `,
};

headerStyles.configureBudgetsButton = {
    css: css`
        white-space: nowrap;
    `,
};
